export default {
  'extension': {
    'command_alert_title': 'Tips',
    'command_alert_content': 'command is for installing local extension',
    'command_title': 'title',
    'command_name': 'name',
    'command_repository_register': 'register',
    'command_repository_register_btn': 'register to repository',
    'command_repository_register_tip': 'register local extension to repository',
    'command_require_title': 'install',
    'command_require_tip': 'composer install command',
    'command_repository_remove': 'remove',
    'command_repository_remove_btn': 'register from repository',
    'command_repository_remove_tip': 'remove local extension from repository',
    'command_unstall_title': 'unstall',
    'command_unstall_tip': 'composer unstall command',
    'command_confirm_tip': 'it will update composer.josn file',

    'table_title': 'Extension',
    'table_description': 'Desc',
    'table_adaptation': 'Adaptation',
    'table_version': 'Version',
    'table_new_version': 'NewVersion',
    'table_authors': 'Authors',
    'table_actions': 'Actions',
    'table_install': 'Install',
    'table_upgrade': 'Upgrade',

    'confirm_install': 'confirm install the extension ({name})？',
    'confirm_installing': 'extension install...',
    'confirm_install_success': 'extension install success',
    'confirm_upgrade': 'confirm upgrade the extension ({name})？',
    'confirm_upgradeing': 'extension upgrade...',
    'confirm_upgrade_success': 'extension upgrade success',

    'settings_save': 'Save',
    'settings_save_success': 'save success',

    'search_title': 'Extension',
    'search_searchword': 'enter keywords',
    'search_status': 'Status',
    'search_status_enable': 'Enable',
    'search_status_disable': 'Disable',
    'search_sort_asc': 'Asc',
    'search_sort_desc': 'Desc',
    'search_btn': 'Search',
    'search_upload': 'Upload',
    'search_install': 'Install',
    'search_refresh': 'Refresh',

    'table_title': 'Extension',
    'table_description': 'Desc',
    'table_adaptation': 'Adaptation',
    'table_version': 'Version',
    'table_authors': 'Authors',
    'table_listorder': 'Sort',
    'table_installtime': 'Installtime',
    'table_installtime_tips': 'install time',
    'table_upgradetime': 'Upgradetime',
    'table_status': 'Status',
    'table_actions': 'Actions',
    'table_detail': 'Detail',
    'table_uninstall': 'Uninstall',
    'table_config': 'Config',
    'table_command': 'Command',

    'dialog_detail': 'Detail',
    'dialog_local': 'Local',
    'dialog_setting': 'Setting',
    'dialog_command': 'Command',

    'confirm_refresh': 'confirm refresh the extension?',
    'confirm_refresh_success': 'refresh the extension success!',
    'confirm_upload_error': 'upload success\'ext must zip!',
    'confirm_upload_success': 'upload success',
    'confirm_upload_force': 'extension exists and want force?',
    'confirm_sort_success': 'sort update success',

    'detail_name': 'Name',
    'detail_title': 'Title',
    'detail_version': 'Version',
    'detail_adaptation': 'Adaptation',
    'detail_description': 'Desc',
    'detail_keywordlist': 'Keywords',
    'detail_homepage': 'Homepage',
    'detail_authorlist': 'Authors',
    'detail_requires': 'Requires',
    'detail_class_name': 'ClassName',
    'detail_installtime': 'Installtime',
    'detail_upgradetime': 'Upgradetime',
    'detail_listorder': 'Sort',
    'detail_status': 'Status',

    'enable_success': 'enable success',
    'disable_success': 'disable success',
    'confirm_uninstall': 'confirm uninstall the extension?',
    'confirm_uninstalling': 'extension uninstall...',
    'confirm_uninstall_success': 'uninstall success'
  }

}
